import actionTypes from '../constants/action-types';

const setSupportedLocales = (state = [], action) => {
  switch (action.type) {
    case actionTypes.SET_SUPPORTED_LOCALES:
      return action.payload.locales;
    default:
      return state;
  }
};

export default setSupportedLocales;
